import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Simple analytics hook for page tracking
// Can be extended to use Google Analytics, Plausible, etc.

interface AnalyticsEvent {
  type: 'pageview' | 'event';
  path: string;
  timestamp: number;
  metadata?: Record<string, any>;
}

const logEvent = (event: AnalyticsEvent) => {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics]', event);
  }
  
  // TODO: Send to analytics service
  // Example: gtag('event', 'page_view', { page_path: event.path });
  // Example: plausible('pageview', { u: event.path });
};

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    logEvent({
      type: 'pageview',
      path: location.pathname + location.search,
      timestamp: Date.now()
    });
  }, [location]);

  return {
    trackEvent: (eventName: string, metadata?: Record<string, any>) => {
      logEvent({
        type: 'event',
        path: location.pathname,
        timestamp: Date.now(),
        metadata: { eventName, ...metadata }
      });
    }
  };
};

export default useAnalytics;
